/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_No_License_P1Inputs */

const es_marketplace_seo_spain_guide_no_license_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No necesitas titulación náutica para alquilar embarcaciones de recreo de hasta 15 CV (velocidad limitada). Es la forma más accesible de ser patrón por un día: tú llevas el timón tras una breve instrucción del armador.`)
};

const gl_marketplace_seo_spain_guide_no_license_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non necesitas titulación náutica para aluguer embarcacións de recreo de ata 15 CV (velocidade limitada). É a forma máis accesible de ser patrón por un día tras unha breve instrución do armador.`)
};

const en_marketplace_seo_spain_guide_no_license_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not need a boating licence for recreational craft up to 15 HP (speed limited). It is the easiest way to be skipper for a day after a short briefing from the owner.`)
};

/**
* | output |
* | --- |
* | "You do not need a boating licence for recreational craft up to 15 HP (speed limited). It is the easiest way to be skipper for a day after a short briefing fr..." |
*
* @param {Marketplace_Seo_Spain_Guide_No_License_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_no_license_p1 = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_No_License_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_No_License_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_no_license_p1(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_no_license_p1(inputs)
	return es_marketplace_seo_spain_guide_no_license_p1(inputs)
});